<template>
  <el-dialog
    title="Bulk Update"
    visible
    width="80vw"
    top="5vh"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('update:isShow', false)"
  >
    <el-alert
      v-show="!isMostRecentAndActiveFuelLevies"
      title="All selected Fuel Levies must be the most recent and active, please review the history"
      type="error"
      :closable="false"
    />

    <el-alert
      v-show="!isSameCarrierFuelLevies"
      title="Cannot bulk update accross multiple Carriers"
      type="error"
      :closable="false"
    />

    <h1>Fuel Levy Updates</h1>
    <el-form
      ref="bulkUpdateForm"
      v-loading="isSaving"
      label-position="top"
      :model="params"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Start"
            prop="date_start"
          >
            <el-date-picker
              v-model="dateStart"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              placeholder="Pick a Start Date"
              :picker-options="datePickerOption"
              class="w-100"
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="End"
            prop="date_end"
          >
            <el-date-picker
              v-model="dateEnd"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              placeholder="Pick a End Date"
              :picker-options="datePickerOption"
              class="w-100"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Active"
            prop="active"
          >
            <el-select
              v-model="active"
              placeholder="Active"
              class="w-100"
            >
              <el-option
                label="Active"
                :value="true"
              />
              <el-option
                label="Inactive"
                :value="false"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <h1>Rates Updates</h1>

      <el-alert
        v-show="!hasUpdateSelected"
        title="You must bulk update at least one field"
        type="error"
        :closable="false"
      />

      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Value"
          >
            <el-input-number
              v-model="rate"
              controls-position="right"
              placeholder="Rate"
              class="ml-2"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>

      <el-button
        type="primary"
        :disabled="validateForm"
        :loading="isSaving"
        @click.native="duplicate"
      >
        Duplicate
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    fuels: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      params: {},
      dateStart: null,
      dateEnd: null,
      active: true,
      rate: null,
      isSaving: false,
      isFullscreen: false,
      datePickerOption: {
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'Yesterday',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'A week ago',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      }
    }
  },
  computed: {
    hasUpdateSelected () {
      return true
    },
    isSameCarrierFuelLevies () {
      // return this.fuels.every(fuel => fuel.carrier.id === this.fuels[0].carrier.id)
      return true
    },
    isMostRecentAndActiveFuelLevies () {
      return this.fuels.every(fuel => fuel.is_most_recent && fuel.active)
    },
    validateForm () {
      return !((this.hasUpdateSelected && this.isSameCarrierFuelLevies && this.isMostRecentAndActiveFuelLevies))
    }
  },
  methods: {
    duplicate () {
      this.isSaving = true
      const job = new this.$sdk.job()
      job.name = 'bulk.combined'
      job.parameters = {
        model_key: 'fuel',
        duplicate: this.fuels.map(fuel => fuel.id),
        update: {
          fields: {
            date_start: this.dateStart ? this.$moment(this.dateStart).format('YYYY-MM-DD 00:00:00') : null,
            date_end: this.dateEnd ? this.$moment(this.dateEnd).format('YYYY-MM-DD 00:00:00') : null,
            active: this.active,
            profile: this.$user.instance.id,
            fuel_rate: this.rate
          }
        }
      }
      job.create()
        .then(() => this.$message({ message: 'Job has been added to the queue', type: 'success' }))
        .finally(() => {
          this.isSaving = false
          this.$emit('update:isShow', false)
        })
    }
  }
}
</script>
